/**
 * Keyboard shortcut registry. Kept tiny on purpose — most of the action lives
 * in `use-hotkeys` and `command-registry`. This module just resolves the
 * "primary" modifier key for the user's platform (Cmd on macOS, Ctrl elsewhere).
 */
export type Mod = "mod" | "ctrl" | "meta";

export function isMac(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Mac|iPod|iPhone|iPad/.test(navigator.platform);
}

/** Resolve `mod` to the literal key the platform expects (`Ctrl` vs `Meta`). */
export function modKey(mod: Mod): string {
  if (mod === "ctrl") return "ctrl";
  if (mod === "meta") return "meta";
  return isMac() ? "meta" : "ctrl";
}

/** Friendly human label — shown in tooltips and the shortcuts dialog. */
export function formatShortcut(keys: string[]): string {
  return keys
    .map((k) => {
      if (k === "mod") return isMac() ? "⌘" : "Ctrl";
      if (k === "shift") return isMac() ? "⇧" : "Shift";
      if (k === "alt" || k === "option") return isMac() ? "⌥" : "Alt";
      return k.length === 1 ? k.toUpperCase() : k;
    })
    .join(isMac() ? "" : "+");
}
